import { VestigingenAanvraagActieDto } from "@/shared/types";
import { parseISO } from "date-fns";
import { VestigingActieMessages, VestigingActieType } from "../constants";
import { Actie } from "./actie";
import { BaseActie } from "./base-actie";

export const VestigingenActie = {
    isVestigingActie: (actie: Actie): actie is VestigingenActie =>
        Object.values(VestigingActieType).includes(actie.type as VestigingActieType),
};

export type VestigingenAangevraagdActie = BaseActie & {
    oudeWaarde: null;
    nieuweWaarde: null;
    type: "VestigingenAangevraagd";
    wijzigingType: "Toegevoegd";
};

export const VestigingenAangevraagdActie = {
    fromDto(dto: VestigingenAanvraagActieDto): VestigingenAangevraagdActie {
        const messages = VestigingActieMessages.VestigingenAangevraagd;
        return {
            id: dto.id,
            type: "VestigingenAangevraagd",
            timelineContent: {
                titel: messages.titel,
                beschrijving: messages.beschrijving,
                actieTekst: messages.actieTekst,
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: "Toegevoegd",
            oudeWaarde: null,
            nieuweWaarde: null,
        };
    },
};

export type VestigingenStopAangevraagdActie = BaseActie & {
    oudeWaarde: null;
    nieuweWaarde: null;
    type: "VestigingenStopAangevraagd";
    wijzigingType: "Toegevoegd";
};

export const VestigingenStopAangevraagdActie = {
    fromDto(dto: VestigingenAanvraagActieDto): VestigingenStopAangevraagdActie {
        const messages = VestigingActieMessages.VestigingenStopAangevraagd;
        return {
            id: dto.id,
            type: "VestigingenStopAangevraagd",
            timelineContent: {
                titel: messages.titel,
                beschrijving: messages.beschrijving,
                actieTekst: messages.actieTekst,
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: "Toegevoegd",
            oudeWaarde: null,
            nieuweWaarde: null,
        };
    },
};

export type LandelijkeFaciliteitenAangevraagdActie = BaseActie & {
    oudeWaarde: null;
    nieuweWaarde: null;
    type: "LandelijkeFaciliteitenAangevraagd";
    wijzigingType: "Toegevoegd";
};

export const LandelijkeFaciliteitenAangevraagdActie = {
    fromDto(dto: VestigingenAanvraagActieDto): LandelijkeFaciliteitenAangevraagdActie {
        const messages = VestigingActieMessages.LandelijkeFaciliteitenAangevraagd;
        return {
            id: dto.id,
            type: "LandelijkeFaciliteitenAangevraagd",
            timelineContent: {
                titel: messages.titel,
                beschrijving: messages.beschrijving,
                actieTekst: messages.actieTekst,
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: "Toegevoegd",
            oudeWaarde: null,
            nieuweWaarde: null,
        };
    },
};

export type LandelijkeFaciliteitenStopAangevraagdActie = BaseActie & {
    oudeWaarde: null;
    nieuweWaarde: null;
    type: "LandelijkeFaciliteitenStopAangevraagd";
    wijzigingType: "Toegevoegd";
};

export const LandelijkeFaciliteitenStopAangevraagdActie = {
    fromDto(dto: VestigingenAanvraagActieDto): LandelijkeFaciliteitenStopAangevraagdActie {
        const messages = VestigingActieMessages.LandelijkeFaciliteitenStopAangevraagd;
        return {
            id: dto.id,
            type: "LandelijkeFaciliteitenStopAangevraagd",
            timelineContent: {
                titel: messages.titel,
                beschrijving: messages.beschrijving,
                actieTekst: messages.actieTekst,
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: "Toegevoegd",
            oudeWaarde: null,
            nieuweWaarde: null,
        };
    },
};

export type VestigingenVerlengingAangevraagdActie = BaseActie & {
    oudeWaarde: string | null;
    nieuweWaarde: string | null;
    type: "VestigingenVerlengingAangevraagd";
    wijzigingType: "Toegevoegd";
};

export const VestigingenVerlengingAangevraagdActie = {
    fromDto(dto: VestigingenAanvraagActieDto): VestigingenVerlengingAangevraagdActie {
        const messages = VestigingActieMessages.VestigingenVerlengingAangevraagd;
        return {
            id: dto.id,
            type: "VestigingenVerlengingAangevraagd",
            timelineContent: {
                titel: messages.titel,
                beschrijving: messages.beschrijving,
                actieTekst: messages.actieTekst,
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: "Toegevoegd",
            oudeWaarde: null,
            nieuweWaarde: null,
        };
    },
};

export type VestigingenActie = VestigingenAangevraagdActie | VestigingenStopAangevraagdActie | VestigingenVerlengingAangevraagdActie;
